interface StepCardProps {
    icon: string;
    step: string;
    title: string;
    description: string;
}

export function StepCard({
    icon,
    step,
    title,
    description,
}: StepCardProps) {
    return (
        <div className="relative flex flex-col items-center text-center">
            <div
                className="
                    flex h-14 w-14 items-center justify-center
                    rounded-[20px]
                    border border-web-primary/40
                    bg-[#080A0D]
                    shadow-web-glow
                "
            >
                <img
                    src={icon}
                    alt={title}
                    className="h-6 w-6 object-contain"
                />
            </div>

            <span className="md:mt-4 mt-2 text-xs uppercase tracking-[0.2em] text-white/50">
                {step}
            </span>

            <h3 className="md:mt-4 mt-2 text-lg font-semibold text-white">
                {title}
            </h3>

            <p className="md:mt-4 mt-2 max-w-[340px] text-sm leading-relaxed text-white/60">
                {description}
            </p>
        </div>
    );
}